"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricsPeriodDataValue = exports.MetricsPeriodPlotWeek = exports.MetricsPeriodPlot = exports.MetricsPlot = exports.SummaryItem = exports.SummaryData = exports.SummaryCard = exports.HoneDashboard = exports.CardTimeframes = exports.CardTypes = void 0;
exports.CardTypes = {
    AP_Aging: "AP Aging",
    Business_Metrics: "Business Metrics",
    Insights: "Insights",
    Profit_and_Loss: "Profit and Loss",
};
exports.CardTimeframes = {
    Current_Week: "Current Week",
    Current_Month: "Current Month",
    Current_Year_to_Date: "Current Year-to-Date",
    Default: "Default",
    Last_Week: "Last Week",
    Last_Month: "Last Month",
    Last_Year: "Last Year",
};
class HoneDashboard {
    constructor(locationId) {
        this.locationId = '';
        this.cards = [];
        this.updatedAt = new Date();
        this.locationId = locationId;
    }
}
exports.HoneDashboard = HoneDashboard;
class SummaryCard {
    constructor(type, timeframe, title) {
        this.title = '';
        this.type = exports.CardTypes.Expenses;
        this.timeframe = exports.CardTimeframes.Last_Week;
        this.data = new SummaryData();
        this.startDate = new Date();
        this.endDate = new Date();
        this.type = type;
        this.timeframe = timeframe;
        this.title = title;
    }
}
exports.SummaryCard = SummaryCard;
class SummaryData {
    constructor() {
        this.items = [];
    }
}
exports.SummaryData = SummaryData;
class SummaryItem {
    constructor(title, amount, percentTitle, percent, startDate, endDate, smoothedAmount, smoothedPercent) {
        this.title = title;
        if (amount)
            this.amount = amount;
        if (percentTitle)
            this.percentTitle = percentTitle;
        if (percent)
            this.percent = percent;
        if (smoothedAmount)
            this.smoothedAmount = smoothedAmount;
        if (smoothedPercent)
            this.smoothedPercent = smoothedPercent;
        if (startDate)
            this.startDate = startDate;
        if (endDate)
            this.endDate = endDate;
    }
}
exports.SummaryItem = SummaryItem;
//Chart Metrics
class MetricsPlot {
    constructor(periodReporting) {
        this.periods = []; // Array of periods with metrics data ready for visualization
        this.metrics = []; // List of all metric identifiers used in the report
        this.periodReporting = periodReporting;
    }
}
exports.MetricsPlot = MetricsPlot;
class MetricsPeriodPlot {
    constructor(date, periodTitle) {
        this.weeks = []; // Array of processed weekly data for visualization
        this.metricKeys = []; // List of metric keys used in this period
        this.date = date;
        this.periodTitle = periodTitle;
    }
}
exports.MetricsPeriodPlot = MetricsPeriodPlot;
class MetricsPeriodPlotWeek {
    constructor(date, currentWeek) {
        this.weekId = date.name ?? `${date.start} - ${date.end}`;
        this.start = date.start;
        this.end = date.end;
        this.currentWeek = currentWeek;
        // Every MetricsPeriodPlotWeek starts out as having noData
        this.noData = true;
        this.data = {};
    }
    addDataValue(key, value) {
        this.data[key] = value;
        this.noData = false;
    }
}
exports.MetricsPeriodPlotWeek = MetricsPeriodPlotWeek;
class MetricsPeriodDataValue {
    constructor(label, value, sortIndex, isSales) {
        this.label = label;
        this.value = value;
        this.sortIndex = sortIndex;
        this.isSales = isSales;
        this.cumulative = value; // Starts out the same as "value", can be reset later
    }
}
exports.MetricsPeriodDataValue = MetricsPeriodDataValue;
//# sourceMappingURL=Dashboard.js.map